<div class="container-wrapper">
    <div class="flexit">
        <div class="header">
            <div class="first-column">
                <div *ngIf="router.url.indexOf('login') === -1 &&
                            router.url.indexOf('home') === -1 &&
                            router.url.indexOf('signup-complete') === -1 &&
                            router.url.indexOf('no-permission') === -1 &&
                            router.url.indexOf('reset-password') === -1 &&
                            router.url.indexOf('profile') === -1 &&
                            router.url.indexOf('request-forgotten-password') === -1" class="show-list" (click)="toggleNav()">
                    <fa-icon [icon]="faBars"></fa-icon>
                </div>
                <div class="logo-container" style="cursor: pointer" routerLink="/">
                    <img class="logo" [src]="logoImgUrl" />
                    <span *ngIf="!!moduleType" class="logo-subtitle" [ngClass]="moduleClass">{{moduleType | translate}}</span>
                </div>
            </div>
        </div>
        <div class="header text-center d-none d-sm-block">
            <div *ngIf="organisationService.organisation">{{organisationService.organisation.name}}</div>
        </div>
        <div  class="header text-end">
            <div style="display: inline-block;">
                <ul *ngIf="loginService.isLoggedIn()" class="navbar-nav ml-auto">
                    <li class="nav-item" ngbDropdown display="dynamic">
                        <a class="nav-link" style="cursor: pointer" ngbDropdownToggle id="navbarDropdown3" role="button">
                            <ng-container *ngIf="appInitializerService.userInfo">
                                <fa-icon [icon]="faUser"></fa-icon> {{appInitializerService.userInfo.name}}
                            </ng-container>
                        </a>
                        <div ngbDropdownMenu aria-labelledby="navbarDropdown3" class="dropdown-menu">
                            <a ngbDropdownItem routerLink="/profile">
                                <fa-icon [icon]="faUser" [fixedWidth]="true"></fa-icon>
                                {{ 'main.header.profile' | translate }}
                            </a>
                            <a ngbDropdownItem (click)="openLangSettings()">
                                <fa-icon [icon]="faLanguage" [fixedWidth]="true"></fa-icon>
                                {{ 'main.header.langSettings.title' | translate }}
                            </a>
                            <div class="dropdown-divider"></div>
                            <a ngbDropdownItem (click)="logout()">
                                <fa-icon [icon]="faSignOut" [fixedWidth]="true"></fa-icon>
                                {{ 'main.header.logout' | translate }}
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
